export const formatUrlSearch = (
  [searchKey, searchValue]: readonly [string, any] | [string, any],
  currentSearch = window.location.search,
) => {
  const search = new URLSearchParams(currentSearch)

  if (!searchValue) {
    if (searchValue === '') {
      search.set(searchKey, '')
      return search.toString().replace(`${searchKey}=`, searchKey)
    }
    search.delete(searchKey)
    return search.toString()
  }

  search.set(searchKey, searchValue)
  return search.toString()
}

export const getUrlSearch = (searchString: string, key: string) => {
  return new URLSearchParams(searchString).get(key)
}
